import React from 'react';
import ReactDOM from 'react-dom';

class ArtworkIntro extends React.Component{


	render(){
		return (<div className="absolute artwork-intro-holder">
				<div className="artwork-intro">
					<p>Create your own version of the album cover.</p>
					<button onClick={this.props.startGenerator}>Start the generator</button>
				</div>
			</div>);
	}
}

export default ArtworkIntro;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/artwork-intro.js